// extracted by mini-css-extract-plugin
module.exports = {"dot":"arrow_dot__2PQ-F","arrow":"arrow_arrow__2rFCz"};